/**
 *
 * PrivateRoute
 *
 * Customized route that redirects non-authenticated users back to the LoginPage
 */

import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useSelector } from 'react-redux';
import session from '../../App/session';

export const PrivateRoute = () => {
    const isAuthenticated = useSelector(session.selectors.selectUserIsLogged);
    if (!isAuthenticated)
        return (
            <Navigate
                to={{
                    pathname: '/login',
                    state: { shouldRefresh: true },
                }}
            />
        );
    return <Outlet />;
};

export default PrivateRoute;
